import React from "react";
import "./App.css";

// Components
import { PromoBanner } from "./components/PromoBanner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ServicesSection } from "./components/ServicesSection";
import { BookingSection } from "./components/BookingSection";
import { LocationsSection } from "./components/LocationsSection";
import { BenefitsSection } from "./components/BenefitsSection";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App">
      <PromoBanner />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <BookingSection />
        <LocationsSection />
        <BenefitsSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;

// Note: This is a 100% static landing page
// No backend required - WhatsApp handles all contact forms
// Ready for Cloudflare Pages, Netlify, Vercel, or any static hosting
